<template>
  <div>
    <select-field label="命令类型" v-model="cmdType" :list="cmdTypes" :disabled="!editable"></select-field>
    <number-field label="数据地址" v-model="address" :disabled="!editable"></number-field>
    <number-field label="寄存器总数量" v-model="regNum" :disabled="!editable"></number-field>
    <submit-field @click="submit" :disabled="!editable || !isValid">确定</submit-field>
  </div>
</template>

<script>
import NumberField from '@/components/utils/number-field'
import SelectField from '@/components/utils/select-field'
import SubmitField from '@/components/utils/submit-field'

export default {
  props: {
    defaults: {
      required: false,
      default: Object.create(null),
      type: Object
    },
    event: {
      required: false,
      default: 'plc-device-data',
      type: String
    },
    editable: {
      required: false,
      default: true,
      type: Boolean
    }
  },
  data () {
    return {
      cmdType: '',
      address: 0,
      regNum: 1
    }
  },
  components: {
    NumberField,
    SelectField,
    SubmitField
  },
  computed: {
    cmdTypes () {
      return [
        {
          key: 'FC1 (readCoils)',
          value: 'readCoils'
        },
        {
          key: 'FC2 (readDiscreteInputs)',
          value: 'readDiscreteInputs'
        },
        {
          key: 'FC3 (readHoldingRegisters)',
          value: 'readHoldingRegisters'
        },
        {
          key: 'FC4 (readInputRegisters)',
          value: 'readInputRegisters'
        }
      ]
    },
    isValid () {
      //        return this.cmdType && this.address
      return true
    }
  },
  methods: {
    refresh () {
      this.cmdType = this.defaults.cmdType
      this.address = this.defaults.address
      this.regNum = this.defaults.regNum
    },
    submit () {
      this.$emitter.emit(this.event, {
        _id: this.defaults._id,
        cmdType: this.cmdType,
        address: this.address,
        regNum: this.regNum
      })

      this.$emitter.once(`${this.event}Resp`, err => {
        if (!err) {
          this.editable = false
        }
      })
    }
  },
  created () {
    this.refresh()
  },
  watch: {
    defaults () {
      this.refresh()
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/home/forms/modbus-data.vue